/* eslint-disable react/require-default-props */
import React, { useCallback } from 'react';
export function ModalOverlay({ onClose, dismissOnBackdropClick = true, onShake }) {
    const handleClick = useCallback(() => {
        if (dismissOnBackdropClick && onClose) {
            onClose();
        }
        else if (!dismissOnBackdropClick && onShake) {
            onShake();
        }
    }, [dismissOnBackdropClick, onClose, onShake]);
    return React.createElement("div", { className: "qmb-ui-modal-overlay", onClick: handleClick, role: "presentation", "aria-hidden": "true" });
}
